import { render, staticRenderFns } from "./site-setup-area-browser.component.vue?vue&type=template&id=0bc6fc3e"
import script from "./site-setup-area-browser.component.ts?vue&type=script&lang=ts&external"
export * from "./site-setup-area-browser.component.ts?vue&type=script&lang=ts&external"
import style0 from "./site-setup-area-browser.component.vue?vue&type=style&index=0&id=0bc6fc3e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc6fc3e')) {
      api.createRecord('0bc6fc3e', component.options)
    } else {
      api.reload('0bc6fc3e', component.options)
    }
    module.hot.accept("./site-setup-area-browser.component.vue?vue&type=template&id=0bc6fc3e", function () {
      api.rerender('0bc6fc3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/site-setup/site-setup-area-browser/site-setup-area-browser.component.vue"
export default component.exports